export function setFavicon(favicon) {
  if (!favicon) {
    return;
  }
  document.head || (document.head = document.getElementsByTagName('head')[0]);
  var n = document.createElement('link');
  var d = document.createElement('link');
  var t = document.getElementById('xlink');
  var a = document.getElementById('plink');
  d.id = 'plink';
  d.rel = 'shortcut icon';
  d.type = 'image/png';
  d.href = favicon;
  n.id = 'xlink';
  n.rel = 'icon';
  n.type = 'image/x-icon';
  n.href = favicon;
  if (t && typeof t == 'object') {
    document.head.removeChild(t);
  }
  if (a && typeof a == 'object') {
    document.head.removeChild(a);
  }
  document.head.appendChild(n);
  document.head.appendChild(d);
}

export function getLangFromCache() {
  try {
    return localStorage.getItem('curr_lang');
  } catch (e) {
    console.log(e);
  }
  return null;
}

export function setLangInCache(lang) {
  try {
    localStorage.setItem('curr_lang', lang);
  } catch (e) {
    console.log(e);
  }
}
export function cloneObjWchg(obj, change, value) {
  var res = {
    active: change == 'active' ? value : obj.active,
    certificate: change == 'certificate' ? value : obj.certificate,
    client_id: change == '​client_id' ? value : obj.client_id,
    entity_id: change == 'entity_id' ? value : obj.entity_id,
    id: change == 'id' ? value : obj.id,
    logo: change == 'logo' ? value : obj.logo,
    metadata: change == 'metadata' ? value : obj.metadata,
    name: change == 'name' ? value : obj.name,
    nameid_format: change == 'nameid_format' ? value : obj.nameid_format,
    secret: change == 'secret' ? value : obj.secret,
    singlesignon_url: change == 'singlesignon_url' ? value : obj.singlesignon_url,
    slug: change == 'slug' ? value : obj.slug,
    type: change == 'type' ? value : obj.type,
  };
  return res;
}

let timerObj = null;
export function delay(ms) {
  clearTimeout(timerObj);
  return new Promise((resolve) => {
    timerObj = setTimeout(resolve, ms);
  });
}
